/**
 * WordPress CMS Static HTML Response model
 */
export class StaticPage {
  constructor(
    public id: number,
    public title: string,
    public content: string,
    public slug: string,
    public acf: any, // Used for displaying an optional description
    public parent?: number,
    public isExpanded?: boolean
  ) {}
}
